export class MapReplyOfficesHTMLElement extends HTMLElement {

    public connectedCallback(): void {
        const mapButton = this.querySelector('.map-button');
        if (mapButton) {
            mapButton.addEventListener('click', this.toggleMap.bind(this));
        }

    }

    public disconnectedCallback(): void {
        const mapButton = this.querySelector('.map-button');
        if (mapButton) {
            mapButton.removeEventListener('click', this.toggleMap.bind(this));
        }
    }


    private toggleMap(event: Event): void {
        event.preventDefault();
        const mapElement: HTMLElement = this.parentElement.querySelector('.map-offices-container');
        const mapInnerElement = mapElement.querySelector('.fit.gmap');
        const officesListElement = this.parentElement.querySelector('.offices-list');
        mapInnerElement.animate([
            //opacity 1 to 0
            { opacity: 0 },
            { opacity: 1 }
        ], {
            duration: 500,
            easing: 'ease-in-out',
            fill: 'forwards'
        });
        officesListElement.animate([
            //opacity 1 to 0
            { opacity: 0 },
            { opacity: 1 }
        ], {
            duration: 500,
            easing: 'ease-in-out',
            fill: 'forwards'
        });

        mapElement.classList.toggle("hidden");
        officesListElement.classList.toggle("hidden");
        const mapButton = this.querySelector('.map-button');
        if (mapElement.classList.contains("hidden")) {
            mapButton.innerHTML = "View Map";
        }
        else {
            mapButton.innerHTML = "View office locations";
        }
    }
}
